import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico_Next",
  "use": "ico_Next-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ico_Next\">\n    <path data-name=\"Path 12234\" d=\"m8.854 20.708-.707-.707 7.646-7.647-7.647-7.646.707-.707 8 8a.5.5 0 0 1 0 .707z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol